<template>
  <div>
    <ts-page-title
      :title="$t('payRollCycleDate.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('payRollCycleDate.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-card>
      <ts-card-wrapper class="d-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click.prevent="addNew">{{
          $t('addNew')
        }}</Button>
        <div class="ts-justify-end ts-space-x-2">
          <ts-input
            v-model="search"
            :placeholder="$t('search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table
          :columns="columns"
          :data="resources"
          size="small"
          :loading="loading"
          highlight-row
          stripe
          max-height="700"
        >
          <template slot-scope="{ row }" slot="monthly_based">
            <span>
              <Icon
                v-if="row.monthly_based"
                type="ios-checkmark-circle-outline text-success"
                size="20"
              />
              <Icon
                v-else
                type="ios-close-circle-outline text-danger"
                size="20"
              />
            </span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              class="text-primary"
              @click.prevent="onEdit(row)"
              v-tooltip="$t('edit')"
            >
              <Icon type="ios-create" size="20" />
            </a>
            <Poptip
              confirm
              :title="$t('areYouSure')"
              @on-ok="onDelete(row)"
              :transfer="true"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
            >
              <a
                class="text-danger"
                v-tooltip="$t('delete')"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
                <Icon type="ios-trash" size="20" v-else />
              </a>
            </Poptip>
          </template>
        </Table>
        <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
          <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
        </div>
        <a-modal
          v-if="showForm"
          v-model="showForm"
          :title="$t('payRollCycleDate.pageTitle')"
          centered
          :zIndex="1020"
          :footer="null"
        >
          <from-action @cancel="clearEdit" @fetchData="fetchData" />
        </a-modal>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FromAction from './form.vue'
import { debounce } from 'lodash'

export default {
  name: 'payroll-cycle-date',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px'
    }
  },

  computed: {
    ...mapState('payroll/payrollCycleDate', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.payroll.payrollCycleDate.search
      },
      set (newValue) {
        this.$store.commit('payroll/payrollCycleDate/SET_SEARCH', newValue)
        this.$store.commit('payroll/payrollCycleDate/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('payRollCycleDate.cycleDateName'),
          key: 'pc_date_name'
        },
        {
          title: this.$t('payRollCycleDate.monthly'),
          key: 'monthly_based',
          slot: 'monthly_based'
        },
        {
          title: this.$t('payRollCycleDate.fromday'),
          key: 'day_from'
        },
        {
          title: this.$t('payRollCycleDate.today'),
          key: 'day_to'
        },
        {
          title: this.$t('payRollCycleDate.firstCycleCalculationCay'),
          key: 'first_cycle_calculation_day'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          className: 'tw-space-x-2',
          width: 90
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('payroll/payrollCycleDate/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    addNew () {
      this.$store.commit('payroll/payrollCycleDate/SET_EDIT_DATA', {})
      this.showForm = true
    },
    clearEdit () {
      this.showForm = false
      this.$store.commit('payroll/payrollCycleDate/SET_EDIT_DATA', {})
      this.fetchData()
    },
    async onDelete (record) {
      record._deleting = true
      this.$store
        .dispatch('payroll/payrollCycleDate/destroy', record.pc_date_id)
        .then(response => {
          this.fetchData()
          record._deleting = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          record._deleting = false
        })
    },
    onEdit (record) {
      this.showForm = true
      this.$store.commit('payroll/payrollCycleDate/SET_EDIT_DATA', record)
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'PAYROLLCYCLEDATE',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
